import cn from 'classnames';
import React from 'react';

import { Summary as Props, types } from './summary.types';
import Text from '../text/text';
import Price from '../price/price';

const Summary: React.FunctionComponent<React.PropsWithChildren<Props>> & {
  types: typeof types;
} = ({
  information,
  price,
  priceLabel,
  rows = [],
  testId,
  title,
  type = Summary.types.default,
}) => (
  <div className="summary__wrapper" data-testid={testId}>
    {title ? (
      <Text variant={Text.variants.hero} size={Text.sizes.basic}>
        {title}
      </Text>
    ) : null}
    <div
      className={cn('summary__content', {
        [`summary__content--${type}`]: type,
      })}
    >
      <div className="summary__rows">
        {rows.map(({ label, value }) => (
          <div className="summary__row" key={label}>
            <Text>{label}</Text>
            <Text theme={Text.themes.medium}>{value}</Text>
          </div>
        ))}
      </div>
      {price ? (
        <div className="summary__price">
          {priceLabel ? <Text>{priceLabel}</Text> : null}
          <Price {...price} />
        </div>
      ) : null}
      {information ? (
        <Text className="summary__information" size={Text.sizes.small}>
          {information}
        </Text>
      ) : null}
    </div>
  </div>
);

Summary.types = types;

export default Summary;
